import React from "react";
import { Route } from "react-router-dom";
import { PtsDashboard } from "../pages";
import InnerMainLayoutPts from "../pages/Pts/_layout/InnerMainLayoutPts";

const PtlRoutes = () => {
  return (
    <>
      <Route element={<InnerMainLayoutPts />}>
        <Route path="/ptl/dashboard" element={<PtsDashboard />} />
        {/* Add more PTL-specific routes here as needed */}
      </Route>
    </>
  );
};

export default PtlRoutes;